import estilo from "./Vivo.module.css";
import tortuga from "../img/tortuga_1.png";
import React, { useEffect, useRef, useState } from "react";
import Peer from "peerjs";

const Vivo = () => {
  const videoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const peerRef = useRef(null);
  const botonRef = useRef(null);

  const [userId, setUserId] = useState("");
  const [input, setInput] = useState("");
  const [activar, setActivar] = useState(false);

  useEffect(() => {
    const startVideo = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: {
            echoCancellation: false, // Desactiva la cancelación de eco
            noiseSuppression: false, // Desactiva la reducción de ruido
            sampleRate: 44100, // Frecuencia de muestreo de 44.1 kHz
            channelCount: 2, // Número de canales (estéreo)
          },
        });

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }

        const peer = new Peer();
        peerRef.current = peer;

        peer.on("open", (id) => {
          setUserId(id);
        });

        peer.on("call", (call) => {
          call.answer(stream);
          call.on("stream", (remoteStream) => {
            if (remoteVideoRef.current) {
              remoteVideoRef.current.srcObject = remoteStream;
              setActivar(true);
            }
          });
        });
      } catch (error) {
        console.error("Error accessing video and audio streams:", error);
      }
    };

    startVideo();
  }, []);

  const [activarCam, setActivarCam] = useState(false);

  const handleCall = () => {
    const remoteUserId = input;
    if (remoteUserId) {
      const call = peerRef.current.call(
        remoteUserId,
        videoRef.current.srcObject
      );
      call.on("stream", (remoteStream) => {
        if (remoteVideoRef.current) {
          remoteVideoRef.current.srcObject = remoteStream;
          setActivarCam(true);
        }
      });
    }
  };

  function capturarInput(e) {
    setInput(e.target.value);
  }

  const [active, setActive] = useState(false);

  // Función para copiar el userId al portapapeles
  const copiarAlPortapapeles = () => {
    navigator.clipboard
      .writeText(userId)
      .then(() => {
        setActive(true);
        setTimeout(() => {
          setActive(false);
        }, 4000);
      })
      .catch(() => {
        setActive(false);
      });
  };

  const cancelarLlamada = () => {
    // Detener la transmisión de video local
    const localStream = videoRef.current.srcObject;
    const tracks = localStream.getTracks();
    tracks.forEach((track) => {
      track.stop();
    });

    // Detener la transmisión de video remota
    const remoteStream = remoteVideoRef.current.srcObject;
    const remoteTracks = remoteStream.getTracks();
    remoteTracks.forEach((track) => {
      track.stop();
    });

    // Cerrar la conexión PeerJS
    peerRef.current.destroy();

    // Restablecer el estado del userId y el input
    setUserId("");
    setInput("");

    window.location.reload();
  };

  return (
    <div className={estilo.video}>
      {active ? (
        <div className={estilo.alerta_copia}>
          <p>ID Copiado</p>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm-1.999 14.413-3.713-3.705L7.7 11.292l2.299 2.295 5.294-5.294 1.414 1.414-6.706 6.706z"></path>
          </svg>
        </div>
      ) : null}

      {videoRef && (
        <div className={estilo.video_contenedor}>
          <div className={estilo.video_emisor}>
            <div className={estilo.emisor}>
              <video ref={videoRef} autoPlay muted />
            </div>

            {userId && (
              <div className={estilo.datos}>
                <p>{userId}</p>
                <button ref={botonRef} onClick={copiarAlPortapapeles}>
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"></path>
                    <path d="M4 22h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2zm2-10h6v2H6v-2zm0 4h6v2H6v-2z"></path>
                  </svg>
                </button>
              </div>
            )}
          </div>

          <div className={estilo.llamar}>
            <input placeholder="Id de conexión" onChange={capturarInput} />
            <button onClick={handleCall}>
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path d="M12 2c-4.963 0-9 4.037-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.963-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z"></path>
                <path d="M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm-1.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 10.5 11z"></path>
              </svg>
            </button>
          </div>

          <div className={estilo.video_receptor}>
            <div className={estilo.receptor}>
              <video ref={remoteVideoRef} autoPlay controls />
            </div>
          </div>

          <button onClick={cancelarLlamada} className={estilo.cancelar}>
            Salir
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M4 19h10.879L2.145 6.265A1.977 1.977 0 0 0 2 7v10c0 1.103.897 2 2 2zM18 7c0-1.103-.897-2-2-2H6.414L3.707 2.293 2.293 3.707l18 18 1.414-1.414L18 16.586v-2.919L22 17V7l-4 3.333V7z"></path>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default Vivo;
